<template>
  <div>

    <div class="wrapper wrapper-full-page">
      <div class="register-page">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-8 col-md-offset-2">
                <div class="header-text">
                  <h2>Last step!</h2>
                  <h4>Provide your billing information and start getting video reviews!</h4>
                  <hr>
                </div>
              </div>
              <div class="col-md-8 col-md-offset-2">
                <form method="#" action="#">
                  <div class="card card-plain">
                    <div class="content">
                      <div class="form-group">
                        <input type="text" placeholder="Company" class="form-control">
                      </div>
                      <div class="form-group">
                        <input type="url" placeholder="Store URL" class="form-control">
                      </div>
                      <div class="form-group">
                        <input type="email" placeholder="Email" class="form-control">
                      </div>
                      <div class="form-group">
                        <input type="password" placeholder="Password" class="form-control">
                      </div>
                      <div class="form-group">
                        <input type="password" placeholder="Password Confirmation" class="form-control">
                      </div>
                    </div>
                    <div class="footer text-center">
                      <button type="button" class="btn btn-fill btn-danger btn-wd">Submit</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright text-center">
              &copy; Copyright 2018 Authentic.net
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/RegisterPay.vue